import {
  fetchWorkoutGroupsBundle,
  getWorkoutEventTypeId,
} from '../api/workoutApi';

const prefetchCache = new Map();

function prefetchKey(eventTypeId, templateId) {
  return `template:${eventTypeId}:${templateId}`;
}

/** Drop cached template workout bundles so edit screens refetch after mutations. */
export function invalidateTemplateWorkoutDetailsPrefetch(templateId = null) {
  if (!templateId) {
    prefetchCache.clear();
    return;
  }
  for (const key of [...prefetchCache.keys()]) {
    if (key.endsWith(`:${templateId}`)) prefetchCache.delete(key);
  }
}

/**
 * Prefetch template workout groups + exercise details so edit screens render instantly.
 */
export function prefetchTemplateWorkoutDetails(get, post, sessionUtils, templateId, workout_group_types = []) {
  if (!templateId) return Promise.resolve(null);
  const eventTypes = sessionUtils?.event_types?.[0]?.event_types || [];
  const eventTypeId = getWorkoutEventTypeId(sessionUtils);
  if (!eventTypeId) return Promise.resolve(null);

  const key = prefetchKey(eventTypeId, templateId);
  if (prefetchCache.has(key)) {
    return prefetchCache.get(key);
  }

  const promise = fetchWorkoutGroupsBundle(get, post, {
    context: 'template',
    templateId,
    planId: null,
    clientId: null,
    eventTypes,
    workout_group_types,
  }).then((bundle) => {
    if (!bundle?.groups?.length) {
      prefetchCache.delete(key);
      return null;
    }
    return bundle;
  });

  prefetchCache.set(key, promise);
  return promise;
}
